import React from "react";
import "./App.css";
import Home from "./page/home";
import About from "./page/about";
import Shop from "./page/shop";
import Miner from "./page/miner";
import s from "./s.module.scss";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";

import { TransitionGroup, CSSTransition } from "react-transition-group";

const Main = () => {
  const location = useLocation();
  return (
    <Switch location={location}>
      <Route path="/shop">
        <Shop />
      </Route>
      <Route path="/about">
        <About />
      </Route>
      <Route path="/miner/:id?">
        <Miner />
      </Route>
      <Route path="/">
        <Home />
      </Route>
    </Switch>
  );
};
const App = () => {
  return (
    <div className={s.wrap}>
      <Router>
        <Main />
      </Router>
    </div>
  );
};

export default App;

// const Main = () => {
//   const location = useLocation();
//   return (
//     <TransitionGroup>
//       <CSSTransition key={location.key} classNames={s.fade} timeout={300}>
//         <Switch location={location}>
//           <Route path="/shop">
//             <Shop />
//           </Route>
//           <Route path="/about">
//             <About />
//           </Route>
//           <Route path="/miner/:id?">
//             <Miner />
//           </Route>
//           <Route path="/">
//             <Home />
//           </Route>
//         </Switch>
//       </CSSTransition>
//     </TransitionGroup>
//   );
// };
